import actions from './actions';
import authActions from '../auth/actions';

const initState = {
  loading: false,
  loaded: false,
  // { base, modules, gracePeriodDays, trialDays }
  plans: null,
  error: null,
};

export default function meagendaPlansReducer(state = initState, action) {
  switch (action.type) {
    case authActions.CLEAR_STATES:
      return { ...initState };
    case actions.LOAD_MEAGENDA_PLANS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actions.MEAGENDA_PLANS_UPDATED:
      return {
        ...state,
        loading: false,
        loaded: true,
        plans: action.payload,
      };
    case actions.MEAGENDA_PLANS_ERROR:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload,
      };
    default:
      return state;
  }
}
